export default "__VITE_ASSET__BIAVzTmB__"